import { useIntl } from 'dibs-react-intl';
import { interiorPhotoMessages } from '../messages';

type Args = {
    firmName?: string | null;
    photoName?: string | null;
};

export function useBuildPhotoTitle(args: Args): string {
    const { firmName, photoName } = args;
    const intl = useIntl();

    let title;
    if (!firmName && !photoName) {
        title = intl.formatMessage(interiorPhotoMessages.titleEmpty);
    } else if (!firmName) {
        title = intl.formatMessage(interiorPhotoMessages.titleNoFirm, { photoName });
    } else {
        title = intl.formatMessage(interiorPhotoMessages.titleFull, { photoName, firmName });
    }
    return `${title} 1stDibs`;
}
